import { render, staticRenderFns } from "./SingleOrder.vue?vue&type=template&id=1bae28cd&"
import script from "./SingleOrder.vue?vue&type=script&lang=js&"
export * from "./SingleOrder.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports